<template>
  <div>
    <div class="flex mx-auto p-4 w-full h-full justify-center">
      <div
        class="flex w-full h-full justify-center  text-blue-800 my-12"
        style="text-align: center"
      >
        <div v-if="dataProvided">
          <i v-if="!failed" class="fas fa-circle-notch fa-spin fa-5x"></i>
          <div v-if="!failed" class="text-xl mt-4">Loading bodyprint</div>
          <div v-if="failed" class="text-xl">Failed to load bodyprint</div>
        </div>
        <div class="w-3/4" v-else>
          <div v-show="!loading">
            <div class="flex flex-row justify-evenly mb-2">
              <div class="w-1/3" v-if="getAuth.bodyprintQueue === true">
                <p class="text-xl font-bold mt-5">
                  Get next bodyprint in queue
                </p>
                <button
                  @click="getQueueItem()"
                  class="text-xl p-3 m-2 bg-blue-800 text-white"
                >
                  Get queue item
                </button>
              </div>

              <div
                class="m-10"
                v-if="
                  getAuth.bodyprintQueue === true &&
                    getAuth.bodyprintSearch === true
                "
              >
                <span>
                  Or
                </span>
              </div>

              <div
                class="w-1/3"
                v-if="
                  getAuth.bodyprintSearch === true ||
                    getAuth.bodyprintList === true
                "
              >
                <p class="text-xl font-bold mt-5">
                  Get bodyprints of selected user
                </p>
                <div class="col-span-6 mt-3 sm:col-span-4">
                  <label
                    for="email_address"
                    class="block font-medium text-xl text-gray-700"
                    >Email address</label
                  >
                  <div class="flex flex-row justify-center">
                    <input
                      id="email_address"
                      type="text"
                      v-model="email"
                      autocomplete="email"
                      placeholder="Email address"
                      class="
                        mt-1
                        p-2
                        border-2 border-solid border-black
                        rounded-md
                        "
                    />
                    <button class="ml-2" @click="clearEmail()">
                      Clear
                    </button>
                  </div>
                </div>
                <div class="col-span-6 sm:col-span-4 flex flex-col items-center">
                  <button
                    @click="searchQueue()"
                    :class="{
                      'text-xl p-3 m-5 mb-2 text-white': true,
                      'bg-blue-800': emailFilled,
                      'bg-gray-600': !emailFilled
                    }"
                    :disabled="!emailFilled"
                  >
                    Search for bodyprints
                  </button>
                </div>
                <p class="text-red-500">{{ this.errorMessage }}</p>
              </div>
            </div>
            <div
              class="flex flex-row w-full justify-center"
              v-if="
                getAuth.bodyprintSearch === true || getAuth.bodyprintList === true
              "
            >
              <div class="w-full">
                <p class="text-xl font-bold mt-5">
                  Bodyprints
                </p>
                <table
                  class="table-fixed w-full border-solid px-4 border-gray-200 border-2 mt-3 bodyprint-table overflow-y-auto"
                  v-if="bodyprints.length > 0"
                >
                  <thead>
                    <tr>
                      <th class="w-3/12">User</th>
                      <th class="w-2/12">Created at</th>
                      <th class="w-2/12">Last updated at</th>
                      <th class="w-3/12">Last editor</th>
                      <th class="w-1/12">Retailer code</th>
                      <th class="w-1/12">Status</th>
                      <th class="w-1/12">User permission</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(bodyprint, index) in this.bodyprints"
                      :key="index"
                    >
                      <td>
                        {{ bodyprint.user ? bodyprint.user.email : "-" }}
                      </td>
                      <td>{{ bodyprint.created_at }}</td>
                      <td>{{ bodyprint.last_updated_at }}</td>
                      <td>{{ bodyprint.last_editor }}</td>
                      <td>{{ bodyprint.retailer_code }}</td>
                      <td>{{ bodyprint.status }}</td>
                      <td>
                        {{ bodyprint.user ? bodyprint.user.permission : "-" }}
                      </td>
                      <td>
                        <div class="flex">
                          <button
                            @click="requestBodyprintToView(bodyprint.id)"
                            class="text-md p-2 m-2 text-white bg-blue-800"
                          >
                            View
                          </button>
                          <button
                            :disabled="bodyprint.status !== 'COMPLETED'"
                            @click="requestBodyprintSizes(bodyprint.id)"
                            :class="{
                              'text-md p-2 m-2 text-white': true,
                              'bg-blue-800': bodyprint.status === 'COMPLETED',
                              'bg-gray-600': bodyprint.status !== 'COMPLETED'
                            }"
                          >
                            Sizes
                          </button>
                          <button
                              :disabled="!bodyprint.editable"
                              @click="requestBodyprint(bodyprint.id)"
                              :class="{
                              'text-md p-2 m-2 text-white': true,
                              'bg-blue-800': bodyprint.editable,
                              'bg-gray-600': !bodyprint.editable
                            }"
                          >
                            Edit
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-else>
                  <p v-if="tableLoading === false">
                    No bodyprints found
                  </p>
                  <i v-else class="fas fa-circle-notch fa-spin fa-5x mt-5"></i>
                </div>
              </div>
            </div>
          </div>
          <i
            v-if="!failed && loading"
            class="fas fa-circle-notch fa-spin fa-5x"
          ></i>
          <div v-if="!failed && loading" class="text-xl mt-4">
            Loading bodyprint
          </div>
          <!-- <div v-else class="text-xl">Failed to load bodyprint</div> -->
          <button v-show="failed && !getQueueEmpty" @click="removeFromQueue()">
            Reject bodyprint
          </button>
          <div v-if="failed && getQueueEmpty" class="text-xl">
            <p>Queue is empty</p>
            <br />
            <button @click="backFromEmpty">Back</button>
          </div>
        </div>
      </div>
    </div>

    <measurements-modal
      :loading="measurementsLoading"
      :showModal="showMeasurementsModal"
      :bodyprint-id="measurementsBodyprint"
      :onClose="() => (showMeasurementsModal = false)"
    />
  </div>
</template>

<script>
import MeasurementsModal from "@/components/modals/measurements-modal.vue";
import { BodyprintMode } from "@/enums";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "BodyprintQueueView",
  components: {
    MeasurementsModal
  },
  computed: {
    BodyprintMode() {
      return BodyprintMode;
    },
    ...mapGetters([
      "getLoading",
      "getAuthLoggedIn",
      "getAuth",
      "getQueueEmpty",
      "getBodyprintMode"
    ]),
    ...mapActions(["authcheck"])
  },
  data() {
    return {
      dataProvided: false,
      loading: false,
      tableLoading: false,
      loaded: false,
      failed: false,
      email: null,
      emailFilled: false,
      code: null,
      errorMessage: null,
      measurementsLoading: false,
      showMeasurementsModal: false,
      measurementsBodyprint: null,
      bodyprints: []
    };
  },
  methods: {
    backFromEmpty() {
      window.location.reload();
    },
    loadbodyPrint() {
      if (!this.$route.params.id && !this.$route.params.bodyprint_id) {
        this.dataProvided = false;
        // this.loaded = true;

        if (this.getAuth.bodyprintList === true) {
          this.getRetailerBodyprints();
        }
      } else if (
        this.$route.params.id !== false &&
        this.$route.bodyprint_id !== false
      ) {
        this.dataProvided = true;
        var user_id = this.$route.params.id;
        var bodyprint_id = this.$route.params.bodyprint_id;

        this.$store
          .dispatch("getBodyprint", { id: user_id, bodyprint_id: bodyprint_id })
          .then(() => {
            this.$store.dispatch("getBodyprintSizes", {
              user: user_id,
              bodyprint: bodyprint_id
            });
            this.$store.dispatch("checkQueue", bodyprint_id);
            this.$store
              .dispatch("getImages", user_id)
              .then(() => {
                this.loaded = true;
                this.$store.dispatch("calculateBodyprint");
              })
              .catch(() => {
                this.failed = true;
              });
          })
          .catch(() => {
            this.failed = true;
          });
      }
    },
    removeFromQueue() {
      var payload = {
        status: "REJECTED",
        rejection_reason: "Bodyprint corrupted"
      };
      this.$store.dispatch("setQueueItemStatus", JSON.stringify(payload));
    },
    getQueueItem() {
      this.loading = true;
      this.$store
        .dispatch("getFirstInQueue")
        .then(() => {
          var bp = this.$store.getters.getBodyPrint;
          if (bp.user) {
            this.$store.dispatch("getBodyprintSizes", {
              user: bp.user,
              bodyprint: bp._id
            });
            this.$store
              .dispatch("getImages", bp.user)
              .then(() => {
                this.loaded = true;
                this.$store.dispatch("calculateBodyprint");
              })
              .catch(() => {
                this.failed = true;
              });
          }
          if (this.$store.getters.getQueueEmpty) {
            this.failed = true;
          }
        })
        .catch(() => {
          this.failed = true;
        });
    },
    searchEmail() {
      this.loading = true;
      this.$store
        .dispatch("getBodyprintByUser", { email: this.email, code: this.code })
        .then(() => {
          var bp = this.$store.getters.getBodyPrint;
          if (bp.user) {
            this.$store.dispatch("getBodyprintSizes", {
              user: bp.user,
              bodyprint: bp._id
            });
            this.$store
              .dispatch("getImages", bp.user)
              .then(() => {
                this.loaded = true;
                this.$store.dispatch("calculateBodyprint");
              })
              .catch(() => {
                this.loading = false;
                this.failed = true;
              });
          }
        })
        .catch(() => {
          this.loading = false;
          this.failed = true;
          this.errorMessage = "Could not find a bodyprint for this user.";
        });
    },
    searchQueue() {
      if (this.email === "" && this.getAuth.bodyprintList === true) {
        this.getRetailerBodyprints();
      } else {
        this.bodyprints = [];
        this.tableLoading = true;
        this.$store
          .dispatch("getBodyprintsByUser", {
            email: this.email,
            code: this.code
          })
          .then(() => {
            this.bodyprints = this.sortedBodyprints();
            this.tableLoading = false;
            this.errorMessage = null;
          })
          .catch(() => {
            this.tableLoading = false;
            this.errorMessage = "Could not find a bodyprint for this user.";
          });
      }
    },
    getRetailerBodyprints() {
      this.bodyprints = [];
      this.tableLoading = true;
      this.$store
        .dispatch("getBodyprintsForRetailer", {})
        .then(() => {
          this.bodyprints = this.sortedBodyprints();
          this.tableLoading = false;
          this.errorMessage = null;
        })
        .catch(() => {
          this.tableLoading = false;
          this.errorMessage = "Could not find bodyprints for this retailer.";
        });
    },
    requestBodyprintToView(id) {
      this.loading = true;
      this.$store
        .dispatch("requestBodyprintToView", { id: id })
        .then(() => {
          var bp = this.$store.getters.getBodyPrint;
          if (bp.user) {
            this.$store.dispatch("getBodyprintSizes", {
              user: bp.user,
              bodyprint: bp._id
            });
            this.$store
              .dispatch("getImages", bp.user)
              .then(() => {
                this.loaded = true;
                this.$store.dispatch("checkBodyprint").then(() => {
                  this.$router.push({
                    name: "check",
                    params: { bodyprint_id: bp._id }
                  });
                });
              })
              .catch(() => {
                this.failed = true;
              });
          }
        })
        .catch(() => {
          this.loading = false;
          this.errorMessage = "Could not find a bodyprint for this user.";
        });
    },
    requestBodyprint(id) {
      this.loading = true;
      this.$store
        .dispatch("requestBodyprint", { id: id })
        .then(() => {
          var bp = this.$store.getters.getBodyPrint;
          if (bp.user) {
            this.$store.dispatch("getBodyprintSizes", {
              user: bp.user,
              bodyprint: bp._id
            });
            this.$store
              .dispatch("getImages", bp.user)
              .then(() => {
                this.loaded = true;
                this.$store.dispatch("editBodyprint").then(() => {
                  this.$router.push({
                    name: "edit",
                    params: { bodyprint_id: bp._id }
                  });
                });
              })
              .catch(() => {
                this.failed = true;
              });
          }
        })
        .catch(() => {
          this.loading = false;
          this.errorMessage = "Could not find a bodyprint for this user.";
        });
    },
    requestBodyprintSizes(id) {
      this.measurementsLoading = true;
      this.$store
        .dispatch("requestBodyprintSizes", { id: id })
        .then(() => {
          this.measurementsLoading = false;
          this.showMeasurementsModal = true;
          this.measurementsBodyprint = id;
        })
        .catch(() => {
          this.measurementsBodyprint = null;
          this.measurementsLoading = false;
          this.errorMessage = "Could not find a bodyprint for this user.";
        });
    },
    requestBodyPrintUserSizes() {
      this.loading = true;
      this.$store
        .dispatch("getBodyprintByUserRaw", {
          email: this.email,
          code: this.code
        })
        .then(() => {
          this.loaded = true;
          this.loading = false;
          this.showMeasurementsModal = true;
        })
        .catch(() => {
          this.loading = false;
          this.errorMessage = "Could not find a bodyprint for this user.";
        });
    },
    clearEmail() {
      this.email = "";
      this.searchQueue();
    },
    sortedBodyprints() {
      return this.$store.getters.getBodyPrints.sort((a, b) => {
        const momentA = moment(a.last_updated_at, "DD-MM-YYYY hh:mm:ss");
        const momentB = moment(b.last_updated_at, "DD-MM-YYYY hh:mm:ss");

        if (momentA.isBefore(momentB)) {
          return 1;
        } else if (momentA.isAfter(momentB)) {
          return -1;
        } else {
          return 0;
        }
      });
    }
  },
  created() {
    if (this.getAuthLoggedIn) {
      this.loadbodyPrint();
    }
  },
  watch: {
    getAuthLoggedIn() {
      if (this.getAuthLoggedIn) {
        this.loadbodyPrint();
      }
    },
    email(newEmail) {
      this.emailFilled = newEmail !== "";
    }
  }
};
</script>

<style>
.logout {
  margin: 10px;
  text-align: right;
  color: #2c5282;
  font-weight: bold;
}

.bodyprint-table {
  max-height: 50vh;
  overflow: scroll;
  display: block;
  background-color: white;
}

.bodyprint-table > thead > tr > th {
  background-color: white;
  padding-top: 16px;
  padding-bottom: 16px;
  position: sticky;
  top: 0;
  z-index: 2;
}
</style>
